import { useQuery } from '@tanstack/react-query';
import apiClient from '@/shared/api/apiClient';
import { GlobalSearchResponse } from '../domain/search.types';

export const searchKeys = {
  all: ['search'] as const,
  global: (searchTerm: string) => [...searchKeys.all, 'global', searchTerm] as const,
};

export function useGlobalSearch(searchTerm: string, enabled: boolean = true) {
  return useQuery({
    queryKey: searchKeys.global(searchTerm),
    queryFn: async () => {
      const response = await apiClient.get<GlobalSearchResponse>('/search', {
        params: {searchTerm, maxResults: 100}
      });
      return response.data;
    },
    enabled: enabled && searchTerm.trim().length >= 2,
    staleTime: 30000, // 30 seconds
  });
}
